import { render } from "./Radar.vue?vue&type=template&id=fddee1a0&scoped=true"
import script from "./Radar.vue?vue&type=script&lang=js"
export * from "./Radar.vue?vue&type=script&lang=js"

import "./Radar.vue?vue&type=style&index=0&id=fddee1a0&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fddee1a0"]])

export default __exports__